// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* 35% transparent version of looks-secondary */

/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* ACTUALLY, THIS IS EDITED ;)
THIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST
GRID UNITS.

ALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM \`layout-contents.js\`*/

/* layout contants from \`layout-constants.js\`, minus 1px */

/* Popover styles */

/* body is for specificity to override some addons that set a lower z-index */

body .Popover {
  /* should be above menu bar */
  z-index: 500;

  /* color-scheme: dark causes very strange issues */
  color-scheme: light;
}

.Popover-body {
  color: var(--paint-text-primary, #575e75);
  background: var(--paint-popover-background, #ffffff);
  border: 1px solid var(--paint-ui-pane-border, #d9d9d9);
  padding: 4px;
  border-radius: 4px;
  padding: 4px;
  -webkit-box-shadow: 0px 0px 8px 1px var(--paint-ui-pane-border, #d9d9d9);
          box-shadow: 0px 0px 8px 1px var(--paint-ui-pane-border, #d9d9d9);
}

.Popover-tipShape {
  fill: var(--paint-popover-background, #ffffff);
  stroke: var(--paint-ui-pane-border, #d9d9d9);
}

.color-picker_clickable_FGUpq {
  cursor: pointer;
}

.color-picker_swatch-row_yRFlX {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
      -ms-flex-direction: row;
          flex-direction: row;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

.color-picker_row-header_HlTqv {
  font-family: 'Helvetica Neue', Helvetica, sans-serif;
  font-size: 0.65rem;
  margin: 8px 8px 0 8px;
}

.color-picker_label-name_IQIlY {
  font-weight: bold;
}

.color-picker_divider_Glu6H {
  border-top: 1px solid var(--paint-ui-pane-border, #d9d9d9);
  margin: 8px;
}

.color-picker_swap-button_CS1Qr {
  margin-left: 8px;
  margin-right: 8px;
}

.color-picker_swatches_RbhAM {
  margin: 8px;
}

.color-picker_swatch_prE8d {
  width: 1.5rem;
  height: 1.5rem;
  border: 1px solid var(--paint-ui-pane-border, #d9d9d9);
  border-radius: 4px;
  -webkit-box-sizing: content-box;
          box-sizing: content-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
}

.color-picker_large-swatch-icon_tOuAd {
  width: 1.75rem;
  margin: auto;
}

.color-picker_large-swatch_Wwvd7 {
  width: 2rem;
  height: 2rem;
}

.color-picker_active-swatch_aTEQ5 {
  border: 1px solid var(--paint-looks-secondary, #855cd6);
  -webkit-box-shadow: 0px 0px 0px 3px var(
  --paint-looks-transparent,
  hsla(260, 60%, 60%, 0.35)
);
          box-shadow: 0px 0px 0px 3px var(
  --paint-looks-transparent,
  hsla(260, 60%, 60%, 0.35)
);
}

.color-picker_swatch-icon_YAc3n {
  width: 1.5rem;
  height: 1.5rem;
}

.color-picker_picker-icon_b1EeY {
  -webkit-filter: var(--paint-filter-icon-gray, none);
          filter: var(--paint-filter-icon-gray, none);
}

.color-picker_inactive-gradient_t34ac {
  -webkit-filter: saturate(0%);
          filter: saturate(0%);
}

.color-picker_gradient-picker-row_QQdGf {
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
      -ms-flex-direction: row;
          flex-direction: row;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin: 8px;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

[dir='ltr'] .color-picker_gradient-picker-row_QQdGf > img + img {
  margin-left: calc(2 * 0.25rem);
}

[dir='rtl'] .color-picker_gradient-picker-row_QQdGf > img + img {
  margin-right: calc(2 * 0.25rem);
}

[dir='rtl'] .color-picker_gradient-swatches-row_uYjMg {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -webkit-flex-direction: row-reverse;
      -ms-flex-direction: row-reverse;
          flex-direction: row-reverse;
}

.color-picker_picker-row_AmLi6 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin: 8px;
  margin-top: 12px;
  width: 150px;
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
}

.color-picker_picker-row_AmLi6 .color-picker_picker-color_vNZx5 {
  border: none;
  border-radius: 0;
  padding: 0 0.2rem;
  width: 3rem;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

.color-picker_picker-row_AmLi6 .color-picker_picker-text_V0JmJ {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  width: 100%;
}

[dir='ltr'] .color-picker_picker-row_AmLi6 .color-picker_picker-text_V0JmJ {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

[dir='rtl'] .color-picker_picker-row_AmLi6 .color-picker_picker-text_V0JmJ {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
`, "",{"version":3,"sources":["webpack://./../scratch-paint/src/components/color-picker/color-picker.css"],"names":[],"mappings":"AAAA;;oDAEoD;;AAEpD,+CAA+C;;AAE/C;;oDAEoD;;AAEpD;;;;kFAIkF;;AAElF,0DAA0D;;AAE1D,mBAAmB;;AAEnB,6EAA6E;;AAE7E;EACE,6BAA6B;EAC7B,YAAY;;EAEZ,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,oDAAoD;EACpD,sDAAsD;EACtD,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,wEAAwE;UAChE,gEAAgE;AAC1E;;AAEA;EACE,8CAA8C;EAC9C,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;MACvB,uBAAuB;UACnB,mBAAmB;EAC3B,yBAAyB;EACzB,sCAAsC;MAClC,sBAAsB;UAClB,8BAA8B;AACxC;;AAEA;EACE,oDAAoD;EACpD,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0DAA0D;EAC1D,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sDAAsD;EACtD,kBAAkB;EAClB,+BAA+B;UACvB,uBAAuB;EAC/B,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,2BAA2B;MACvB,sBAAsB;UAClB,mBAAmB;AAC7B;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uDAAuD;EACvD;;;CAGD;UACS;;;CAGT;AACD;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mDAAmD;UAC3C,2CAA2C;AACrD;;AAEA;EACE,4BAA4B;UACpB,oBAAoB;AAC9B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;MACvB,sBAAsB;UAClB,mBAAmB;EAC3B,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;MACvB,uBAAuB;UACnB,mBAAmB;EAC3B,wBAAwB;EACxB,+BAA+B;MAC3B,qBAAqB;UACjB,uBAAuB;EAC/B,WAAW;EACX,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,mCAAmC;MAC/B,+BAA+B;UAC3B,2BAA2B;AACrC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;MACvB,sBAAsB;UAClB,mBAAmB;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,8BAA8B;UACtB,sBAAsB;EAC9B,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,8BAA8B;UACtB,sBAAsB;EAC9B,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B","sourcesContent":["/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* 35% transparent version of looks-secondary */\n\n/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* ACTUALLY, THIS IS EDITED ;)\nTHIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST\nGRID UNITS.\n\nALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM `layout-contents.js`*/\n\n/* layout contants from `layout-constants.js`, minus 1px */\n\n/* Popover styles */\n\n/* body is for specificity to override some addons that set a lower z-index */\n\nbody :global(.Popover) {\n  /* should be above menu bar */\n  z-index: 500;\n\n  /* color-scheme: dark causes very strange issues */\n  color-scheme: light;\n}\n\n:global(.Popover-body) {\n  color: var(--paint-text-primary, #575e75);\n  background: var(--paint-popover-background, #ffffff);\n  border: 1px solid var(--paint-ui-pane-border, #d9d9d9);\n  padding: 4px;\n  border-radius: 4px;\n  padding: 4px;\n  -webkit-box-shadow: 0px 0px 8px 1px var(--paint-ui-pane-border, #d9d9d9);\n          box-shadow: 0px 0px 8px 1px var(--paint-ui-pane-border, #d9d9d9);\n}\n\n:global(.Popover-tipShape) {\n  fill: var(--paint-popover-background, #ffffff);\n  stroke: var(--paint-ui-pane-border, #d9d9d9);\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.swatch-row {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n\n.row-header {\n  font-family: 'Helvetica Neue', Helvetica, sans-serif;\n  font-size: 0.65rem;\n  margin: 8px 8px 0 8px;\n}\n\n.label-name {\n  font-weight: bold;\n}\n\n.divider {\n  border-top: 1px solid var(--paint-ui-pane-border, #d9d9d9);\n  margin: 8px;\n}\n\n.swap-button {\n  margin-left: 8px;\n  margin-right: 8px;\n}\n\n.swatches {\n  margin: 8px;\n}\n\n.swatch {\n  width: 1.5rem;\n  height: 1.5rem;\n  border: 1px solid var(--paint-ui-pane-border, #d9d9d9);\n  border-radius: 4px;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.large-swatch-icon {\n  width: 1.75rem;\n  margin: auto;\n}\n\n.large-swatch {\n  width: 2rem;\n  height: 2rem;\n}\n\n.active-swatch {\n  border: 1px solid var(--paint-looks-secondary, #855cd6);\n  -webkit-box-shadow: 0px 0px 0px 3px var(\n  --paint-looks-transparent,\n  hsla(260, 60%, 60%, 0.35)\n);\n          box-shadow: 0px 0px 0px 3px var(\n  --paint-looks-transparent,\n  hsla(260, 60%, 60%, 0.35)\n);\n}\n\n.swatch-icon {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.picker-icon {\n  -webkit-filter: var(--paint-filter-icon-gray, none);\n          filter: var(--paint-filter-icon-gray, none);\n}\n\n.inactive-gradient {\n  -webkit-filter: saturate(0%);\n          filter: saturate(0%);\n}\n\n.gradient-picker-row {\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin: 8px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n[dir='ltr'] .gradient-picker-row > img + img {\n  margin-left: calc(2 * 0.25rem);\n}\n\n[dir='rtl'] .gradient-picker-row > img + img {\n  margin-right: calc(2 * 0.25rem);\n}\n\n[dir='rtl'] .gradient-swatches-row {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n  -webkit-flex-direction: row-reverse;\n      -ms-flex-direction: row-reverse;\n          flex-direction: row-reverse;\n}\n\n.picker-row {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 8px;\n  margin-top: 12px;\n  width: 150px;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.picker-row .picker-color {\n  border: none;\n  border-radius: 0;\n  padding: 0 0.2rem;\n  width: 3rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n}\n\n.picker-row .picker-text {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 100%;\n}\n\n[dir='ltr'] .picker-row .picker-text {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n[dir='rtl'] .picker-row .picker-text {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clickable": `color-picker_clickable_FGUpq`,
	"swatch-row": `color-picker_swatch-row_yRFlX`,
	"swatchRow": `color-picker_swatch-row_yRFlX`,
	"row-header": `color-picker_row-header_HlTqv`,
	"rowHeader": `color-picker_row-header_HlTqv`,
	"label-name": `color-picker_label-name_IQIlY`,
	"labelName": `color-picker_label-name_IQIlY`,
	"divider": `color-picker_divider_Glu6H`,
	"swap-button": `color-picker_swap-button_CS1Qr`,
	"swapButton": `color-picker_swap-button_CS1Qr`,
	"swatches": `color-picker_swatches_RbhAM`,
	"swatch": `color-picker_swatch_prE8d`,
	"large-swatch-icon": `color-picker_large-swatch-icon_tOuAd`,
	"largeSwatchIcon": `color-picker_large-swatch-icon_tOuAd`,
	"large-swatch": `color-picker_large-swatch_Wwvd7`,
	"largeSwatch": `color-picker_large-swatch_Wwvd7`,
	"active-swatch": `color-picker_active-swatch_aTEQ5`,
	"activeSwatch": `color-picker_active-swatch_aTEQ5`,
	"swatch-icon": `color-picker_swatch-icon_YAc3n`,
	"swatchIcon": `color-picker_swatch-icon_YAc3n`,
	"picker-icon": `color-picker_picker-icon_b1EeY`,
	"pickerIcon": `color-picker_picker-icon_b1EeY`,
	"inactive-gradient": `color-picker_inactive-gradient_t34ac`,
	"inactiveGradient": `color-picker_inactive-gradient_t34ac`,
	"gradient-picker-row": `color-picker_gradient-picker-row_QQdGf`,
	"gradientPickerRow": `color-picker_gradient-picker-row_QQdGf`,
	"gradient-swatches-row": `color-picker_gradient-swatches-row_uYjMg`,
	"gradientSwatchesRow": `color-picker_gradient-swatches-row_uYjMg`,
	"picker-row": `color-picker_picker-row_AmLi6`,
	"pickerRow": `color-picker_picker-row_AmLi6`,
	"picker-color": `color-picker_picker-color_vNZx5`,
	"pickerColor": `color-picker_picker-color_vNZx5`,
	"picker-text": `color-picker_picker-text_V0JmJ`,
	"pickerText": `color-picker_picker-text_V0JmJ`
};
export default ___CSS_LOADER_EXPORT___;
